// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ComptabiliteExports_root__2xGlA {\n  margin-top: 1rem;\n}\n", "",{"version":3,"sources":["webpack://src/Components/Comptabilite/ComptabiliteExports.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB","sourcesContent":[".root {\n  margin-top: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "ComptabiliteExports_root__2xGlA"
};
export default ___CSS_LOADER_EXPORT___;
